module.exports = __webpack_public_path__ + "assets/img/join-team-btn-a53b5023.png";